import { Component, OnInit, OnDestroy, ElementRef, ViewChild, Renderer2} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

// Plugin
import Swal from 'sweetalert2';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';

// Service
import { ApiService } from '../../../shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';
import { cpuUsage } from 'process';

/* jquery */
declare var $: any;

@Component({
  selector: 'app-career',
  templateUrl: './form-career.component.html',
  styles: [
  ]
})
export class FormCareerComponent implements OnInit, OnDestroy {

  @ViewChild('recaptcha', {static: true }) recaptchaElement: ElementRef;
  dataPosition;
  dataRegional;
  dataEducational = ["SMK/SMA", "S1", "S2", "S3"];
  formCareer;
  supportFile;
  fileReceive;
  careerFile;
  public files: NgxFileDropEntry[] = [];
  send:boolean;
  captchaResponse = '';
  infoCaptcha = false;
  isLang;

  constructor( private renderer: Renderer2,
                private activedRoute: ActivatedRoute,
                private elem: ElementRef,
                private apiService: ApiService,
                private globalService: GlobalService) {}

  ngOnInit(): void {
    // MultiLanguage
   this.isLang =  this.apiService.isLang();

    // Meta
    this.apiService.getDataApi('getSubHeaderByLink/career').subscribe(response => {
      this.globalService.updateMeta(
        response.data.title + ' | Prime Agri Resources',
        response.data.keyword,
        response.data.metadesc
      );
    });

    this.activedRoute.queryParams.subscribe(params => {
      // Regional
      this.apiService.getDataApi('getRegionalCareer').subscribe(response => {
        response.data.forEach((v, i) => {
          if(v.id == params.regional) {
            this.dataRegional = v;
          }
        });
      });

      // Position
      this.apiService.getDataApi('getRegionalCareer?regional='+params.regional).subscribe(response => {
        response.data.forEach((v, i) => {
          if(v.id == params.position) {
            this.dataPosition = v;
          }
        });
      });
    });

    // Captcha
    this.addRecaptchaScript();

    this.renderer.addClass(document.body, 'select-ver3');
  }

  public dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    for (const droppedFile of files) {

      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          if(file.type == "application/msword" || file.type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || file.type == "application/pdf" || file.type == ""){
            if(file.size < 3500000) {
              this.supportFile = '';
              this.fileReceive = true;
            } else {
              this.supportFile = 'File size is over capacity  ( max file size 3MB )'
              this.fileReceive = false;
            }
          }else{
            this.supportFile = 'Only format file: .pdf, .doc, .docx, or .rtf'
            this.fileReceive = false;
          }

          this.careerFile = file;

          // Here you can access the real file

          /**
          // You could upload it like this:
          const formData = new FormData()
          formData.append('logo', file, relativePath)

          // Headers
          const headers = new HttpHeaders({
            'security-token': 'mytoken'
          })

          this.http.post('https://mybackend.com/api/upload/sanitize-and-save-logo', formData, { headers: headers, responseType: 'blob' })
          .subscribe(data => {
            // Sanitized logo returned from backend
          })
          **/

        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        // console.log(droppedFile.relativePath, fileEntry);
      }
    }
  }

  onSubmit(careerForm: NgForm){
    if(this.captchaResponse != ''){
      var formData = new FormData();
      if(this.dataRegional && this.dataPosition) {
        formData.append('regional_id', this.dataRegional.id);
        formData.append('position_id', this.dataPosition.id);
      }
      formData.append('fullname', careerForm.value.fullname);
      formData.append('date_birth', careerForm.value.date_birth);
      formData.append('gender', careerForm.value.gender);
      formData.append('address', careerForm.value.address);
      formData.append('phone', careerForm.value.phone);
      formData.append('email', careerForm.value.email);
      formData.append('educational', careerForm.value.educational);
      // formData.append('company', careerForm.value.company);
      // formData.append('position', careerForm.value.position);
      // formData.append('start_date', careerForm.value.startDate);
      // formData.append('end_date', careerForm.value.endDate);
      // formData.append('detail', careerForm.value.giveDetail);
      formData.append('file', this.careerFile);
      this.send = true;
      this.infoCaptcha = false;
      if(careerForm.form.valid){
        this.apiService.postDataApi('saveCareer', formData).subscribe(
          data => { 
            if(data.success == true) {
              Swal.fire({
                icon: 'success',
                text:  data.message
              });
            } else {
              Swal.fire({
                icon: 'warning',
                text:  data.message
              });
            }
            this.send = false;
            careerForm.resetForm();
            this.files = [];
            this.fileReceive = false;
          },
          error => { 
            Swal.fire({
              icon: 'error',
              text: 'Failed, please try again!'
            });
            this.send = false;
          }
        ); 
        window['grecaptcha'].reset();
        this.captchaResponse = '';
      }
    }else{
      this.infoCaptcha = true;
    }
  }

  renderReCaptcha() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey' : '6LeT670ZAAAAAJCzg17P5mvqFLAQO4Vw_IS-J_Ua',
      'callback': (response) => {
        this.captchaResponse = response;
      }
    });
  }

  addRecaptchaScript() {
    window['grecaptchaCallback'] = () => {
      this.renderReCaptcha();
    }
  
    (function(d, s, id, obj){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { obj.renderReCaptcha(); return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));
  }

  ngOnDestroy(){
    this.renderer.removeClass(document.body, 'select-ver3');
    /* clear select2 */
    const selectOptionsContainer = $('.select2-container');
    selectOptionsContainer.removeClass('select2-container--open');
  }

}